<template>
<div class="app flex-row">
  
  <div v-if="!isAccomodationRequestAvailable" class="container">
    <b-row class="justify-content-center">
      <b-col md="12">
        <b-card>
          <b-card-body>
            <h3 class="text-center mb-4">Application for Short Stay in SoamiBagh</h3>
            <p class="text-left" style="white-space: pre-line;">
  {{ accoRequestMessage }}
</p>
           </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
    
  <div v-if="isAccomodationRequestAvailable" class="container">
    <b-row class="justify-content-center">
      <b-col md="12">
        <b-card v-if="!validIdentity">
          <b-card-body>
            <h3 class="text-center mb-4">Validate Identity</h3>
            <b-form-group label="Soami Bagh Id Card No" label-for="valid-id-card-no" label-cols-sm="4" label-cols-lg="3">
              <b-form-input :state="chkState2('idCardNo')"  id="valid-id-card-no" type="text" v-model.lazy.trim="$v.form2.idCardNo.$model" placeholder="Soami Bagh Id Card No" autofocus/>
            </b-form-group>
            <hr/>
            <h3 class="text-center mb-4">OR</h3>
            <b-form-group label="Full Name" label-for="valid-flname" label-cols-sm="4" label-cols-lg="3">
              <b-form-input :state="chkState2('flname')" id="valid-flname" type="text" v-model.lazy.trim="$v.form2.flname.$model" placeholder="Full Name" />
            </b-form-group>
            <b-form-group label="Date of Brith" label-for="dob" label-cols-sm="4" label-cols-lg="3">
              <v-date-picker  :formats='formats' v-model="form2.dob" :input-props='{ class: "form-control" }' show-caps>
              </v-date-picker>
            </b-form-group>
            <b-form-group label="City" label-for="valid-city" label-cols-sm="4" label-cols-lg="3">
              <b-form-input :state="chkState2('city')"   id="valid-city" type="text" v-model.lazy.trim="$v.form2.city.$model" placeholder="City" />
            </b-form-group>
            <b-button type="submit" variant="primary" @click="validateIdentity" :disabled="$v.form2.$invalid"  align="cener">
              Validate
            </b-button>

          </b-card-body>
        </b-card>

        <b-card v-if="validIdentity">
          <b-card-body>
            <h3 class="text-center mb-4">Application for Short Stay in Soami Bagh</h3>
            <b-form v-on:submit.prevent="onSubmit" v-on:reset.prevent="onReset" novalidate>
              <b-form-group label="Bhandara/Satsang" label-cols-sm="4" label-cols-lg="3">
                <event-type-select v-model="$v.form.eventType.$model"></event-type-select>
                <b-form-invalid-feedback id="liveFeedbackIdEventType" :state="chkState('eventType')">
                  Please select Bhandara/Satsang
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Soami Bagh Id Card No" label-for="id-card-no" label-cols-sm="4" label-cols-lg="3">
                <b-form-input readonly id="id-card-no" type="text" aria-describedby="liveFeedbackIdCardNo" :state="chkState('idCardNo')" v-model.lazy.trim="$v.form.idCardNo.$model" placeholder="Soami Bagh Id Card No" autofocus :disabled="noIdCard" @change="changeIdCardNo"/>
                <b-form-invalid-feedback id="liveFeedbackIdCardNo">
                  This is a required field
                </b-form-invalid-feedback>
                <b-form-checkbox disabled class="mt-2" @change="noIdCard = !noIdCard">I don't have Soamibagh Issued I-Card</b-form-checkbox>
              </b-form-group>

              <b-form-group v-if="noIdCard" label="Why don't you have Id Card?" label-for="id-card-reason" label-cols-sm="4" label-cols-lg="3">
                <v-select :options="reasonOptions"
                  placeholder="Please select why you don't have the Id Card"
                  v-model="$v.form.idCardReason.$model">
                </v-select>
              </b-form-group>

              <b-form-group v-if="noIdCard" label="Name Of Applicant" label-for="applicant-name" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="applicant-name" type="text" aria-describedby="liveFeedbackApplicantName" :state="chkState('applicantName')" v-model.lazy.trim="$v.form.applicantName.$model" placeholder="Name Of Applicant" autofocus />
                <b-form-invalid-feedback id="liveFeedbackApplicantName">
                  This is a required field
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group  label="City Of Applicant" label-for="applicant-city" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="applicant-city" type="text" aria-describedby="liveFeedbackApplicantCity" :state="chkState('applicantcity')" v-model.lazy.trim="$v.form.applicantcity.$model" placeholder="City Of Applicant" autofocus />
                <b-form-invalid-feedback id="liveFeedbackApplicantCity">
                  This is a required field
                </b-form-invalid-feedback>
              </b-form-group>


              <b-form-group v-if="noIdCard" label="Any I-Card No" label-for="other-card-number" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="other-card-number" type="text" aria-describedby="liveFeedbackOtherCardNo" :state="chkState('otherCardNo')" v-model.lazy.trim="$v.form.otherCardNo.$model" autofocus placeholder="Like aadhar etc." />
                <b-form-invalid-feedback id="liveFeedbackOtherCardNo">
                  This is a required field
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group v-if="noIdCard" label="Updeshi or Non Updeshi" label-cols-sm="4" label-cols-lg="3">
                <b-form-radio-group v-model="$v.form.isUpdeshi.$model" class="pt-2" :state="chkState('isUpdeshi')">
                  <b-form-radio value="1">Updeshi</b-form-radio>
                  <b-form-radio value="0">Non Updeshi</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

              <b-form-group v-if="noIdCard" label="Address" label-for="address" label-cols-sm="4" label-cols-lg="3">
                <b-form-textarea id="address" aria-describedby="liveFeedbackAddress" :state="chkState('address')" v-model.lazy.trim="$v.form.address.$model" placeholder="Address" rows="3" max-rows="6">
                </b-form-textarea>
                <b-form-invalid-feedback id="liveFeedbackAddress">
                  This is a required field
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group v-if="noIdCard" label="Name of Referral (Correspondent)" label-for="referralName" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="referralName" type="text" aria-describedby="liveFeedbackReferralName" :state="chkState('referralName')" v-model.lazy.trim="$v.form.referralName.$model" autofocus placeholder="Name of Referral" />
                <b-form-invalid-feedback id="liveFeedbackReferralName">
                  This is a required field
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Number of members visiting" label-for="numberMembers" label-cols-sm="4" label-cols-lg="3">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button variant="outline-info" @click="removeMember">Remove Member</b-button>
                  </b-input-group-prepend>
                  <b-form-input v-model="numberOfMembers" disabled></b-form-input>
                  <b-input-group-append>
                    <b-button variant="success" @click="addMember">Add Member</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>

              <member-list ref="memberList"></member-list>
        
              <b-form-group  label="Date of Arrival" label-for="arrivalDate"  label-cols-sm="4" label-cols-lg="3">
                                <b-form-datepicker id="arrivalDate" name="arrivalDate" :min="form.todate ? form.todate : min"
                                    :initial-date="min" :state="validateState('arrivalDate')"
                                    v-model.trim="$v.form.arrivalDate.$model" aria-describedby="liveFeedbackFromDate"
                                    placeholder="DD/MM/YYYY" today-button reset-button close-button autofocus
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />

                                    <b-form-invalid-feedback id="liveFeedbackFromDate">Please enter Date of Arrival</b-form-invalid-feedback>

                            </b-form-group>

               
               
                  <b-form-group label="Arrival Time" label-for="fromTime"  label-cols-sm="4" label-cols-lg="3">
                                <b-input-group class="mb-3">
                                    <b-form-input id="fromTime-input" v-model="$v.form.fromTime.$model" type="text"
                                        placeholder="HH:mm"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-timepicker id="fromTime" name="fromTime" v-model="$v.form.fromTime.$model"
                                            button-only right locale="en" :state="chkState('fromTime')"
                                            aria-describedby="liveFeedbackFromTime" now-button reset-button
                                            aria-controls="fromTime-input"></b-form-timepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback id="liveFeedbackFromTime">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
            
           

                            <b-form-group  label="Date of Departure" label-for="departureDate" label-cols-sm="4" label-cols-lg="3">
                                <b-form-datepicker id="departureDate" name="departureDate" :min="form.arrivalDate ? form.arrivalDate : min"
                                    :state="validateState('departureDate')" v-model.trim="$v.form.departureDate.$model"
                                    aria-describedby="liveFeedbackToDate" placeholder="DD/MM/YYYY" today-button
                                    reset-button close-button autofocus
                                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" />
                                    <b-form-invalid-feedback id="liveFeedbackTiDate">Please enter Date of Departure</b-form-invalid-feedback>
                            </b-form-group>
          
                <b-form-group label="Departure Time" label-for="toTime"  label-cols-sm="4" label-cols-lg="3">
                                <b-input-group class="mb-3">
                                    <b-form-input id="toTime-input" v-model="$v.form.toTime.$model" type="text"
                                        placeholder="HH:mm"></b-form-input>
                                    <b-input-group-append>
                                        <b-form-timepicker id="toTime" name="toTime" v-model="$v.form.toTime.$model"
                                            button-only right locale="en" :state="chkState('toTime')"
                                            aria-describedby="liveFeedbackToTime" now-button reset-button
                                            aria-controls="toTime-input"></b-form-timepicker>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-form-invalid-feedback id="liveFeedbackToTime">
                                    This is a required field.
                                </b-form-invalid-feedback>
                            </b-form-group>
             

             

              <b-form-group label="Contact Number" label-for="phone" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="phone" type="text" aria-describedby="liveFeedbackContactNumber" :state="chkState('phone')" v-model.lazy.trim="$v.form.phone.$model" placeholder="Contact Number" />
                <b-form-invalid-feedback id="liveFeedbackContactNumber">
                  This is a required field
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Email" label-for="email" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="email" type="text" aria-describedby="liveFeedbackEmail" :state="chkState('email')" v-model.lazy.trim="$v.form.email.$model" placeholder="Email" />
                <b-form-invalid-feedback id="liveFeedbackEmail">
                  This is a required field
                </b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Any member(s) medical constraint" label-for="medicalConstraint" label-cols-sm="4" label-cols-lg="3">
                <b-form-input id="medicalConstraint" type="text" aria-describedby="liveFeedbackMedicalConstraint" v-model.lazy.trim="$v.form.medicalConstraint.$model" placeholder="Any member(s) medical constraint" />
              </b-form-group>

              <b-form-group label="Type of accomodation" label-for="accomodation-type" label-cols-sm="4" label-cols-lg="3">
                <v-select :options="['DORMITORY', 'ROOM']"
                  placeholder="Please choose the type of accomodation"
                  v-model="$v.form.accomodation_type.$model">
                </v-select>
              </b-form-group>

              <b-form-group label="Type of toilet" label-for="accomodation-type" label-cols-sm="4" label-cols-lg="3">
                <v-select :options="['DESI', 'WESTERN']"
                  placeholder="Please choose the type of toilet"
                  v-model="$v.form.toilet_type.$model">
                </v-select>
              </b-form-group>

              <b-form-group label="AC ROOM" label-for="ac-room" label-cols-sm="4" label-cols-lg="3">
                <v-select :options="['YES', 'NO']"
                  placeholder="Please choose AC Room "
                  v-model="$v.form.ac_room.$model">
                </v-select>
              </b-form-group>

              <b-form-group label="Eating at Bhandarghar" label-for="meal" label-cols-sm="4" label-cols-lg="3">
                <v-select :options="['YES', 'NO']"
                  placeholder="Please choose If eating at Bhandarghar "  
                  v-model="$v.form.meal.$model">
                </v-select>
              </b-form-group>              

              <b-form-group label="Comments" label-for="comments" label-cols-sm="4" label-cols-lg="3">
                <b-form-textarea
                  id="comments"
                  v-model="$v.form.comments.$model"
                  placeholder="Please provide us 3 prefered building names"
                  rows="3"
                  max-rows="6"
                  :state="chkState('comments')"
                ></b-form-textarea>
              </b-form-group>

              <div class="form-group" align="left">
                <label class="control-label" style="font-style: italic;">Submitting this application form in no way confirms that applicant has been provided the preferred accommodation. That shall be communicated further.
                  <br><br> ***IMPORTANT NOTES*** <br>
                  Your application may not be considered, if the application is incomplete or inaccurate.
                  <br><br> -> During Bhandara days no separate room shall be given to a single occupant.
                  <br> -> On arrival if it is found that the information regarding number of members visiting is different, the room allotted can be changed.
                  <br> -> In case there are changes in the arrival and departure date, please inform accommodation department timely on the same email and using the same application number provided during the time of submission of the application.
                  <br> -> If applicant is not arriving within 24 hrs of the day informed, the allotment shall be cancelled.
                  <br> -> In case not having Soamibagh ID card, reference from your Correspondent or Centre Incharge is essential.
                  <br><br> BY CLICKING 'SUBMIT' BUTTON BELOW, I CONFIRM THAT I HAVE READ ALL IMPORTANT NOTES GIVEN ABOVE AND SHALL ABIDE BY IT.</label>
              </div>

              <b-button type="submit" variant="primary">
                Submit
              </b-button>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="modalSuccess" @hide="confirm" okOnly>
      <div class="d-block text-center">
        <h4>Form Has Been Submitted Succesfully. We Will Send You An Acknoledgement Email Very Soon. Your reference number is {{application_number}}</h4>
      </div>
    </b-modal>

  </div>
</div>
</template>

<script>
import Vue from 'vue'
import {
  required,
  email
} from "vuelidate/lib/validators"

import EventTypeSelect from './EventTypeSelect'
import BuildingSelect from './BuildingSelect'
import MemberList from './MemberList'

const formShape2 = {
  idCardNo: "",
  flname: "",
  dob: null,
  city: ""  
}
const formShape = {
  eventType: null,
  idCardNo: "",
  idCardReason: null,
  applicantName: "",
  applicantcity: "",
  otherCardNo: "",
  isUpdeshi: null,
  referralName: "",
  address: "",
  arrivalDate: new Date(),
  departureDate: new Date(),
  phone: "",
  email: "",
  medicalConstraint: "",
  accomodation_type: null,
  toilet_type: null,
  ac_room: null,
  comments: "",
  meal: null,
  fromTime: null,
  toTime: null
}

export default {
  name: 'Accomodation',
  components: {
    EventTypeSelect,
    BuildingSelect,
    MemberList
  },
  computed: {
    isValid() {
      return !this.$v.form.$anyError
    },
    isValid2() {
      return !this.$v.form2.$anyError
    },
    isDirty2() {
      return this.$v.form2.$anyDirty
    },
    isDirty() {
      return this.$v.form.$anyDirty
    }
  },
  validations() {
    if(this.validIdentity == false){
      let form2 = this.form2.idCardNo.length > 0 ? {
        idCardNo: {
          required
        },
        dob: {},
        flname: {},
        city: {},

      } :{
          idCardNo: {},
          flname: {
            required
          },
          dob: {
            required
          },
          city: {
            required
          }
      }
      return{
        form2
      }
    }
    else{
    let form = !this.noIdCard ? {
      idCardNo: {
        required
      }
    } : {
      idCardNo: {},
      idCardReason: {
        required
      },
      applicantName: {
        required
      },
      applicantcity: {
            required
      },
      otherCardNo: {
        required
      },
      isUpdeshi: {
        required
      },
      address: {
        required
      },
      referralName: {
        required
      },
      meal: {
        required
      },
      fromTime: { required },
         
         toTime: { required },
    }

    _.merge(form, {
      eventType: {
        required
      },
      arrivalDate: {
        required
      },
      departureDate: {
        required
      },
      phone: {
        required
      },
      email: {
        required,
        email
      },
      applicantcity: {
            required
      },
      medicalConstraint: {},
      accomodation_type: {
        required
      },
      toilet_type: {
        required
      },
      ac_room: {
        required
      },
      meal: {
        required
      },
      fromTime: { required },
         
         toTime: { required },
      comments: {
        required
      }
    })

    return {
      form
    }
  }
  },
  data: function() {
    return {
      min: new Date(),
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['DD/MM/YYYY', 'DD-MM-YYYY','YYYY-MM-DD', 'YYYY/MM/DD'], // Only for `v-date-picker`
        dayPopover: 'L', // Only for `v-date-picker`
        data: ['L', 'DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY/MM/DD'] // For attribute dates
      },
      application_number : null,
      form: Object.assign({}, formShape),
      form2: Object.assign({}, formShape2),
      validIdentity: false,
      noIdCard: false,
      numberOfMembers: 0,
      isAccomodationRequestAvailable: true,
      accoRequestMessage: 'Accodmodation request is currently unavailable. Please contact administrator.',
      customer: null,
      yesNoOptions: [{
          text: 'Yes',
          value: 1
        },
        {
          text: 'No',
          value: 0
        }
      ],
      reasonOptions: [
        {label: "New to Satsang", value: "NEW_TO_SATSANG"},
        {label: "Support to elder person", value: "SUPPORT_ELDER_PERSON"},
        {label: "Child", value: "CHILD"},
      ]
    };
  },
  methods: {
    validateState(name) {
            const { $dirty, $error } = this.$v.form[name];
            return $dirty ? !$error : null;
        },
    validateIdentity(){
        this.validIdentity = false;

        if (this.validate2() ) {
          this.$nextTick(() => {
            let params = {
              id_card_no: this.form2.idCardNo.length == 0 ? null : this.form2.idCardNo,
              fl_name:  this.form2.flname.length == 0 ? null : this.form2.flname,
              city:  this.form2.city.length == 0 ? null : this.form2.city,
              dob: this.formatDate(this.form2.dob)
            }

            this.$store.dispatch('reservations/validateSatsangi', params)
              .then((response) => {
                if(response.data.success == false){
                    this.showErrorMsg({
                      message: response.data.error
                    });
                    this.validIdentity = false;
                }
                else{
                        this.validIdentity = true;
                    //    this.customer = response.data.customer;
                    if(response.data != null && response.data.customer != null && response.data.customer.length > 0){
                      this.customer = response.data.customer[0];
                      //this.form.email = this.customer.email;
                      this.form.idCardNo = this.customer.id_card_no;
                     // this.form.phone = this.customer.phone;
                      this.form.applicantcity = this.customer.city;
                      this.changeIdCardNo(this.form.idCardNo);
                    }

                }
              })
              .catch((error) => {
                if (error.response.status == 400) {
                  this.showErrorMsg({
                    message: error.response.data.error
                  })
                }
                else if (error.response.status == 422){
                    this.showErrorMsg({
                      message: error.response.data.error
                    });
                }
                else {
                  this.showErrorMsg()
                }
                this.validIdentity = false;
              })

          })
        }





    },
    changeIdCardNo(value) {
      this.$store.dispatch('customers/getCustomer', {id_card_no: value})
      .then((customer) => {
        if (customer) {
          this.numberOfMembers = 1
         // this.form.email = customer.email
         // this.form.phone = customer.phone
          this.$refs.memberList.setMember(customer)
        }

      })
    },
    addMember() {
      if (this.numberOfMembers < 20) {
        this.numberOfMembers++
        this.$refs.memberList.addMember()
      }
    },
    removeMember() {
      if (this.numberOfMembers > 0) {
        this.numberOfMembers--
        this.$refs.memberList.removeMember()
      }
    },
    onSubmit() {
      let returnValue = this.compareDates(this.form.arrivalDate, this.form.departureDate);
      console.log(returnValue);
      if(returnValue == false){
        this.showErrorMsg({
                message: "Departure date must be after the arrival date"
              })
        return;      
      }
      if (this.validate() && this.$refs.memberList.validate()) {
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            event_type_id: this.form.eventType.value,
            id_card_no: this.noIdCard ? null : this.form.idCardNo,
            id_card_reason: this.noIdCard ? this.form.idCardReason.value : null,
            applicant_name: this.noIdCard ? this.form.applicantName : null,
            applicant_city: this.form.applicantcity,
            other_card_no: this.noIdCard ? this.form.otherCardNo : null,
            is_updeshi: this.noIdCard ? this.form.isUpdeshi : null,
            address: this.noIdCard ? this.form.address : null,
            referral_name: this.noIdCard ? this.form.referralName : null,
            members: this.$refs.memberList.getMembers(),
            arrival_date: this.formatDate(this.form.arrivalDate),
            departure_date: this.formatDate(this.form.departureDate),
            phone: this.form.phone,
            email: this.form.email,
            medical_constraint: this.form.medicalConstraint,
            accomodation_type: this.form.accomodation_type,
            toilet_type: this.form.toilet_type,
            ac_room: this.form.ac_room,
            bhandarghar_ticket: this.form.meal,
            comments: this.form.comments,
            preferred_buildings: [],
            arrival_time: this.form.fromTime,
            departure_time: this.form.toTime
          }

          this.$store.dispatch('reservations/createReservation', params)
            .then((response) => {
              console.log(response);
              this.showSuccessMsg()
              this.application_number = response.data.data.application_number;
              this.$refs.modalSuccess.show()
              this.onReset()
            })
            .catch((error) => {
              this.showErrorMsg({message: error})
            })

        })
      }
    },
    onCancel() {
      this.$emit('cancel')
    },
    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape)
      this.form2 = Object.assign({}, formShape2)
      this.$refs.memberList.onReset()
      this.submitted = false
      this.validIdentity = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    confirm() {
     // this.onReset()
      this.numberOfMembers = 0    
    },
    chkState2(val) {
      const field = this.$v.form2[val]
      return field.$dirty ? !field.$invalid : null
    },
    chkState(val) {
      const field = this.$v.form[val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate2() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid2
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  beforeMount() {
     this.$store.dispatch('attributes/isAccoRequestAvailable')
        .then((response) => {
          console.log(response);
          if(response.data.available == false){
            this.isAccomodationRequestAvailable = false;
            this.accoRequestMessage = response.data.message;
          }
          else{
            this.isAccomodationRequestAvailable = true;
          }
        })
        .catch(() => {
            this.showErrorMsg('Unable to find accomodation request status. Please contact administrator.');
            this.isAccomodationRequestAvailable = false;            
        })
  },
  mounted() {
   
    this.validIdentity = false;
    this.form.arrivalDate = this.formatDate(new Date())

    this.form.departureDate = this.$moment().add(1, 'days').toDate()
  


  }
}
</script>

<style>
.col-form-label {
  font-weight: 600;
}
</style>
